import React from 'react';
import ReferenceGenerator from '../../../components/ReferenceGenerator';
import { WASTE_MANAGEMENT_TYPES_URL } from '../../../constants/urls';

export default function WasteManagementTypeReferencePage() {
  return (
    <ReferenceGenerator url={WASTE_MANAGEMENT_TYPES_URL} />
  );
}
